/* eslint-disable camelcase */
  <template >
  <div>
    <br>
  <div>
  <div class="formPosition">

<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
    <template>
      <v-card style="margin:auto;" width="1200">
        <v-container   style="background-color:#006699; color:white;border-bottom:1px solid white;">
      <div>
         <span>Informação sobre a sua  Licença de utilização</span>

      </div>
  </v-container>

         <v-card-text>
            <v-row>
              <v-col md="2">
                  <span style="font-weight:bold;">Plano activado:</span>
              </v-col>
              <v-col md="4">
                  <span>Mensal</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="2">
                  <span style="font-weight:bold;">Estado actual:</span>
              </v-col>
              <v-col md="4">
                  <span>{{(daysLeft===0)?'Vencida': 'Em utilização'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="2">
                  <span style="font-weight:bold;">Data de activação:</span>
              </v-col>
              <v-col md="4">
                  <span>-</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="2">
                  <span style="font-weight:bold;">Data de expiração:</span>
              </v-col>
              <v-col md="4">
                  <span>{{dataExpiracao}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="3">
                  <span style="font-weight:bold;">Dias restantes de utilização:</span>
              </v-col>
              <v-col md="4">
                  <span>{{daysLeft}}</span>
              </v-col>
            </v-row>
         </v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn v-if="daysLeft === 0" color="primary" @click="$router.push('RenovarLicenca')">Renovar licença?</v-btn>
         </v-card-actions>
      </v-card>
    </template>

  </v-row>
  </v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    isLoading_: false,
    daysLeft: ''
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    },

    returnInstituicao () {
      return ls.get('i_id')
    },
    dataExpiracao () {
      return ls.get('dataExpiracao')
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    // this.InitializeInstituicoes()
    this.daysLeft = utilitarios.NumberOfDayLeft(new Date(), ls.get('dataExpiracao'))
  },

  methods: {

  }

}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
